var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9375 2.41162L8.5 6.63037L15.5312 2.41162M2.875 12.5611C1.83947 12.5611 1 11.7216 1 10.6861V3.34912C1 2.31359 1.83947 1.47412 2.875 1.47412H14.125C15.1605 1.47412 16 2.31359 16 3.34912V10.6861C16 11.7216 15.1605 12.5611 14.125 12.5611H2.875Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmail);
export default __webpack_public_path__ + "static/media/Iconmail.32bf723f133e57010e40a7abd516264f.svg";
export { ForwardRef as ReactComponent };